import { CSSProperties } from 'react'

export const s = {
  button: {
    fontSize: 14,
    fontWeight: 600,
    borderColor: '#595959',
  } as CSSProperties,
}
